<template>
    <div>
        <breadCrumb 
            :icon="'fa-calendar-alt'"
            :category="$t(`sideNav.navMySalon`)"
            :subCategory="$t(`subMenu.my_salon_staffs`)"
            :subSubCategory="''">
        </breadCrumb>
      <div v-if="!addToggle" class="text-right mt-3 mr-5">
            <!--<button v-b-modal.modal-add class="btn buttons-csv buttons-html5 btn-outline-primary" type="button" :title="$t('button_link.add') + $t(`subMenu.my_salon_appointment`)" @click="addToggle = !addToggle">
                <span class="fal fa-plus mr-2"></span>
                <span>{{$t('button_link.add')}}{{$t(`subMenu.my_salon_appointment`)}}</span>
            </button> -->
            <div class="px-3 px-sm-5 py-4">
                        <StaffList ref="staffList" :tab="selectedTab"></StaffList>
            </div>
        </div>
    </div>
</template>
<script>
import BreadCrumb from './../../Bread_Crumb'
import StaffList from './Staff_List'
export default {
    name: 'MenuStaff',
    components: {
        BreadCrumb, 
        StaffList
    },
    data(){
        return{
            addToggle: false,
            selectedTab: 'list'
        }
    },
}
</script>